import { C } from "../styles";

function LoginPage({ onLogin }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: C.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Dot grid */}
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'radial-gradient(var(--border-2) 1.5px, transparent 1.5px)',
        backgroundSize: '28px 28px',
        pointerEvents: 'none',
      }} />

      {/* Orb 1 — indigo, top-left */}
      <div className="orb-1" style={{
        position: 'absolute',
        width: '560px', height: '560px',
        background: 'radial-gradient(circle, rgba(99,102,241,0.18) 0%, transparent 68%)',
        top: '-140px', left: '-140px',
        pointerEvents: 'none',
      }} />

      {/* Orb 2 — violet, bottom-right */}
      <div className="orb-2" style={{
        position: 'absolute',
        width: '480px', height: '480px',
        background: 'radial-gradient(circle, rgba(139,92,246,0.15) 0%, transparent 68%)',
        bottom: '-100px', right: '-100px',
        pointerEvents: 'none',
      }} />

      {/* Orb 3 — blue, top-right */}
      <div className="orb-3" style={{
        position: 'absolute',
        width: '320px', height: '320px',
        background: 'radial-gradient(circle, rgba(96,165,250,0.1) 0%, transparent 68%)',
        top: '10%', right: '8%',
        pointerEvents: 'none',
      }} />

      {/* Card */}
      <div className="fade-in-up ui-card" style={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: '16px',
        padding: '52px 44px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
      }}>
        {/* Logo */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          <img src="/logo.png" alt="Second Orbit" style={{ height: '96px', width: 'auto', objectFit: 'contain' }} />
        </div>

        <h1 className="gradient-text" style={{
          fontSize: '28px', fontWeight: '800',
          letterSpacing: '-0.03em', marginBottom: '10px',
        }}>
          Second Orbit Data Portal
        </h1>

        <p style={{ fontSize: '14px', color: C.text2, lineHeight: '1.6', marginBottom: '36px' }}>
          Contributor access portal for<br />project asset submissions
        </p>

        {/* Divider */}
        <div style={{ height: '1px', background: 'var(--border)', marginBottom: '36px' }} />

        {/* Google sign-in */}
        <button className="google-btn" onClick={onLogin} style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
          width: '100%', padding: '14px 20px',
          background: 'var(--surface-2)',
          border: '1px solid var(--border-2)',
          borderRadius: '10px',
          color: C.text1, fontSize: '15px', fontWeight: '600',
          cursor: 'pointer', letterSpacing: '-0.01em',
        }}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt=""
            style={{ width: '18px' }}
          />
          Continue with Google
        </button>

        <p style={{ marginTop: '24px', fontSize: '12px', color: C.text3 }}>
          Secure sign-in via Google OAuth 2.0
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
